import { useCallback, useEffect, useState } from "react";
import KitReleaseControl from "@/components/KitReleaseControl";
import CombinedRollout from "@/components/CombinedRollout";
import PhotoPilot from "@/components/PhotoPilot";
import CustomerPhotoValidation from "@/components/CustomerPhotoValidation";
import CopyCheck from "@/components/CopyCheck";
import { api, errText } from "@/lib/api";

export default function ReleaseControl() {
  const [state, setState] = useState(null);
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);
  const [removed, setRemoved] = useState(false);
  const refresh = useCallback(async () => {
    try { setState((await api.get("/admin/release")).data); setError(""); }
    catch (e) { setError(errText(e)); }
  }, []);
  useEffect(() => { refresh(); }, [refresh]);
  const act = async (action) => {
    setBusy(true);
    try {
      setState((await api.post(`/admin/release/${action}`, {
        deployment: state.deployment, instance: state.instance,
        predecessor: state.drained_deployment || "",
        predecessor_removed_verified: removed,
      })).data);
      setError("");
    } catch (e) { setError(errText(e)); }
    finally { setBusy(false); }
  };
  return <main className="max-w-3xl mx-auto p-8 space-y-5">
    <h1 className="font-display text-3xl">Release control</h1>
    <p>Administrator operations. Checkout stays available. During the transition, content requests may ask users to retry.</p>
    {error && <p role="alert">{error}</p>}
    {state && <>
      <dl className="space-y-2">{Object.entries(state).map(([key,value]) =>
        <div key={key}><dt className="font-semibold">{key}</dt><dd className="break-all">{typeof value === "object" ? JSON.stringify(value) : String(value)}</dd></div>)}</dl>
      {state.mode === "bridge" && <button className="btn-outline" disabled={busy} onClick={() => act("drain")}>Drain content writers</button>}
      {state.mode === "final" && state.phase !== "v2" && <>
        <label className="flex gap-3"><input type="checkbox" checked={removed} onChange={e => setRemoved(e.target.checked)} />Railway confirms the predecessor deployment is REMOVED.</label>
        <button className="btn-gold" disabled={busy || !removed || !state.drained_deployment || state.in_flight !== 0} onClick={() => act("activate")}>Activate verified accounting</button>
      </>}
    </>}
    <button className="btn-outline block" disabled={busy} onClick={refresh}>Refresh status</button>
    <PhotoPilot />
    <CombinedRollout />
    <KitReleaseControl />
    <CopyCheck />
    <CustomerPhotoValidation />
  </main>;
}
